type TAppErrorOptions = {
  expected?: boolean;
  context?: Record<string, unknown>;
};

export class AppError extends Error {
  public readonly expected: boolean;
  public readonly context?: Record<string, unknown>;

  constructor(message: string, options: TAppErrorOptions = {}) {
    super(message);
    this.name = 'AppError';
    this.expected = options.expected ?? false;
    this.context = options.context;
  }
}
